import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

let uid = 0;

@Component({
  selector: 'ui-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule],
  templateUrl: './ui-input.component.html',
})
export class UiInputComponent {
  readonly control = input.required<FormControl<any>>();
  readonly label = input.required<string>();
  readonly type = input<'text' | 'number' | 'date'>('text');
  readonly placeholder = input('');
  readonly hint = input('');
  readonly prefix = input('');
  readonly suffix = input('');
  readonly required = input(false);
  /** Shown but not editable — for values another step owns. */
  readonly readonly = input(false);

  readonly id = `ci-in-${uid++}`;

  readonly invalid = computed(() => {
    const c = this.control();
    return c.invalid && (c.touched || c.dirty);
  });

  readonly errorText = computed(() => {
    const e = this.control().errors ?? {};
    if (e['required']) return `${this.label()} is required.`;
    if (e['positiveNumber']) return `${this.label()} must be greater than zero.`;
    return 'Check this value.';
  });
}
